import { getMileageTemplate } from "../../shortcodes/templates";
import { getShortcodeWrapper, addShortcodeToEditor } from "../../shortodeAddition";

const selectMileageConfig = (tinymce, uuid, shortcodeOnClick) => {
  tinymce.activeEditor.windowManager.open({
    title: "Select Mileage Button",
    body: {
      type: "panel",
      items: [
        {
          type: "input",
          name: "url",
          label: "URL",
          placeholder: "https://domain.com",
        },
        {
          type: "selectbox",
          name: "color",
          label: "Button color",
          items: [
            { value: "green", text: "Green" },
            { value: "blue", text: "Blue" },
          ],
        },
        {
          type: "selectbox",
          name: "openLink",
          label: "Open link in...",
          items: [
            { value: "_self", text: "Same window tab" },
            { value: "_blank", text: "New window tab" },
          ],
        },
      ],
    },
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "submit",
        name: "submit",
        text: "Add",
        primary: true,
      },
    ],
    onSubmit: api => {
      const data = api.getData();
      const parentElement = tinymce.activeEditor.selection.getNode().nodeName.toLowerCase();

      const templateToAdd = getMileageTemplate({
        url: data.url,
        color: data.color,
        tab: data.openLink,
      });

      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd);
      addShortcodeToEditor(shortcodeWrapper, uuid, parentElement, api);
      api.close();
    },
  });
};

export { selectMileageConfig };
